import React from "react";
import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import api from "../api";
import dayjs from "dayjs";

type Props = {
    dateRange: [dayjs.Dayjs, dayjs.Dayjs] | null;
};

const DownloadFlightsButton: React.FC<Props> = ({ dateRange }) => {
    const handleDownload = async () => {
        if (!dateRange || dateRange.length !== 2) {
            alert("Please select a valid date range first.");
            return;
        }

        const [start, end] = dateRange;
        try {
            const response = await api.get("/cc/flights-download/", {
                params: {
                    start_date: start.format("YYYY-MM-DD"),
                    end_date: end.format("YYYY-MM-DD"),
                },
                responseType: "blob",
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `flights_${start.format("YYYY-MM-DD")}_to_${end.format("YYYY-MM-DD")}.zip`
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            alert("Download failed. Please try again.");
            console.error(error);
        }
    };

    return (
        <Button
            icon={<DownloadOutlined />}
            onClick={handleDownload}
            disabled={!dateRange || dateRange.length !== 2}
            className="rounded-md"
        >
            Download Flights
        </Button>
    );
};

export default DownloadFlightsButton;
